"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.APDatePickerDropdown = void 0;
exports["default"] = APDatePicker;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _formGeneratorHelper = require("../../../helpers/formGeneratorHelper");
require("./APDatePickerDropdown.css");
var _formValidations = require("../../../helpers/formValidations");
var _excluded = ["label", "meta", "info"],
  _excluded2 = ["validate"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var APDatePickerDropdown = /*#__PURE__*/function (_React$Component) {
  function APDatePickerDropdown(props) {
    var _this;
    _classCallCheck(this, APDatePickerDropdown);
    _this = _callSuper(this, APDatePickerDropdown, [props]);
    _defineProperty(_this, "handleChange", function (date) {
      _this.props.input.onChange(date);
      if (_this.props.customChange) {
        _this.props.customChange(date);
      }
      _this.setState({
        date: new Date(date)
      });
    });
    _defineProperty(_this, "getClasses", function () {
      var customClasses = _this.props.customClasses;
      return (0, _cssClassesHelper.getBEMClasses)(['ap-datepicker-dropdown', 'ap-select', customClasses]);
    });
    _defineProperty(_this, "getDays", function () {
      var date = _this.state.date;
      var leadingZero = _this.props.leadingZero;
      var daysCount = _this.getDaysInMonth(date);
      return (0, _formGeneratorHelper.generateOptionsFromNumber)(1, daysCount + 1, leadingZero ? 2 : 0);
    });
    _defineProperty(_this, "getMonths", function () {
      var t = _this.props.t;
      var months = [{
        value: 0,
        text: t('January')
      }, {
        value: 1,
        text: t('February')
      }, {
        value: 2,
        text: t('March')
      }, {
        value: 3,
        text: t('April')
      }, {
        value: 4,
        text: t('May')
      }, {
        value: 5,
        text: t('June')
      }, {
        value: 6,
        text: t('July')
      }, {
        value: 7,
        text: t('August')
      }, {
        value: 8,
        text: t('September')
      }, {
        value: 9,
        text: t('October')
      }, {
        value: 10,
        text: t('November')
      }, {
        value: 11,
        text: t('December')
      }];
      return months.map(function (month) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: month.value,
          value: month.value
        }, month.text);
      });
    });
    _defineProperty(_this, "getYears", function () {
      var _this$props = _this.props,
        minYear = _this$props.minYear,
        maxYear = _this$props.maxYear,
        leadingZero = _this$props.leadingZero;
      var today = new Date();
      minYear = minYear || 1900;
      maxYear = maxYear || today.getFullYear();
      return (0, _formGeneratorHelper.generateOptionsFromNumber)(minYear, maxYear + 1, leadingZero ? 2 : 0).reverse();
    });
    _defineProperty(_this, "onDayChange", function (e) {
      var value = e.target.value;
      var date = _this.state.date;
      date.setDate(+value);
      _this.handleChange(date);
    });
    _defineProperty(_this, "onMonthChange", function (e) {
      var value = e.target.value;
      var date = _this.state.date;
      var currentDays = date.getDate();

      // If user's selected month has less days than the actual month we set the day to the latest in that given month
      // else month will change to next because of the days difference
      date.setDate(1);
      date.setMonth(value);
      var monthDays = _this.getDaysInMonth(date);
      if (currentDays > monthDays) date.setDate(monthDays);
      _this.handleChange(date);
    });
    _defineProperty(_this, "onYearChange", function (e) {
      var value = e.target.value;
      var date = _this.state.date;
      date.setFullYear(value);
      _this.handleChange(date);
    });
    _defineProperty(_this, "getCurrentValue", function () {
      var date = _this.state.date;
      return {
        day: date.getDate(),
        month: date.getMonth(),
        year: date.getFullYear()
      };
    });
    _this.state = {
      date: new Date()
    };
    return _this;
  }
  _inherits(APDatePickerDropdown, _React$Component);
  return _createClass(APDatePickerDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.input.value;
      if (value) {
        var date = new Date(value);
        this.setState({
          date: date
        });
      }
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      return new Date(date.getYear(), date.getMonth() + 1, 0).getDate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        label = _this$props2.label,
        meta = _this$props2.meta,
        info = _this$props2.info,
        otherProps = _objectWithoutProperties(_this$props2, _excluded);
      var baseClasses = this.getClasses();
      var value = this.getCurrentValue();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group ".concat(baseClasses('select-wrapper'))
      }, /*#__PURE__*/_react["default"].createElement("label", {
        className: "ap--label ".concat(baseClasses('label'))
      }, label), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('input')
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({
        value: value.day,
        className: baseClasses('select'),
        onChange: this.onDayChange
      }, otherProps), this.getDays()), /*#__PURE__*/_react["default"].createElement("select", _extends({
        value: value.month,
        className: baseClasses('select'),
        onChange: this.onMonthChange
      }, otherProps), this.getMonths()), /*#__PURE__*/_react["default"].createElement("select", _extends({
        value: value.year,
        className: baseClasses('select'),
        onChange: this.onYearChange
      }, otherProps), this.getYears())), /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-text-muted ".concat(baseClasses('info'))
      }, info), meta.dirty && meta.error && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('error', 'dpk-error')
      }, meta.error));
    }
  }]);
}(_react["default"].Component);
_defineProperty(APDatePickerDropdown, "propTypes", {
  input: _propTypes["default"].object.isRequired,
  label: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  info: _propTypes["default"].string,
  meta: _propTypes["default"].shape({
    touched: _propTypes["default"].bool,
    error: _propTypes["default"].string
  }),
  disabled: _propTypes["default"].bool,
  leadingZero: _propTypes["default"].bool,
  minYear: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  maxYear: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  minDate: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  maxDate: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)])
});
_defineProperty(APDatePickerDropdown, "defaultProps", {
  label: 'Date',
  customClass: 'custom-datepicker',
  info: '',
  disabled: false,
  leadingZero: true
});
var APDatePickerTranslated = exports.APDatePickerDropdown = (0, _reactI18next.withTranslation)('core')(APDatePickerDropdown);
var minDateProp;
var maxDateProp;
var maxDateValidation = function maxDateValidation(value) {
  return maxDateProp && (0, _formValidations.maxDate)(value, new Date(maxDateProp));
};
var minDateValidation = function minDateValidation(value) {
  return minDateProp && (0, _formValidations.minDate)(value, new Date(minDateProp));
};
var maxMinValidations = [maxDateValidation, minDateValidation];
function APDatePicker(props) {
  minDateProp = props.minDate;
  maxDateProp = props.maxDate;
  var validate = props.validate,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var validators = validate ? [].concat(_toConsumableArray(validate), maxMinValidations) : maxMinValidations;
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({}, otherProps, {
    component: APDatePickerTranslated,
    validate: validators,
    name: props.name
  }));
}